import dayjs from "dayjs";

// A duplicate is a new challenge, so it must not inherit the source's start
// time (usually in the past, which blocks Continue). Leave a few minutes of
// slack so the default is still in the future when the coach clicks Continue.
export const DUPLICATE_START_LEAD_MINUTES = 5;

export const getInitialStartTime = ({
  isDuplicateMode,
  scheduledAt,
  now = dayjs(),
}) => {
  if (isDuplicateMode) {
    return dayjs(now)
      .add(DUPLICATE_START_LEAD_MINUTES, "minute")
      .second(0)
      .millisecond(0);
  }
  return scheduledAt ? dayjs(scheduledAt) : null;
};
